var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("FlashNewsForm", {
        attrs: {
          loading: _vm.editStore.isLoading,
          values: _vm.editStore.data,
          errors: _vm.editStore.formErrors,
          admin: true,
          submitText: "Update",
        },
        on: { submit: _vm.updateFlashNews },
        model: {
          value: _vm.media,
          callback: function ($$v) {
            _vm.media = $$v
          },
          expression: "media",
        },
      }),
      _vm._v(" "),
      _c(
        "ActionButton",
        {
          staticClass: "btn-danger",
          attrs: { type: "button" },
          on: { click: _vm.destroyFlashNews },
        },
        [_vm._v("\n        Delete\n    ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }